import { SourceType } from "Data/detail";
import { SourceProps } from "./detail";

// note : data of about introduce
export const DATA_INTRODUCE_TEXT: string = `답은 우리에게 있습니다. 프로젝트에 참여하는 구성원 모두, 그리고 청소년들과 숫자 42처럼 질문에 대한 답을 찾아가는 과정을 만들고자 합니다.
답을 찾기 위한 여정에서 인간의 상상력이 그 이정표가 되어 줄 것입니다. 우리의 상상력으로 질문하며 이야기를 만들고, 몸으로 경험하는 새로운 세계를 창작하고자 합니다.
예술에 있어 기술은 위협의 존재가 아닌 표현의 도구이자 실현의 도구로 작동합니다. 상상력을 자극하고 창의적인 아이디어를 실현 가능하게 할 뿐만 아니라, IT기술 자체가 예술이 되기도 합니다.`;

export const DATA_INTRODUCE_GALLERY: SourceProps[] = [
	/*
	{
		id: "0",
		type: SourceType.IMAGE,
		value: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
	},
	{
		id: "1",
		type: SourceType.IMAGE,
		value: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
	},
	{
		id: "2",
		type: SourceType.VIDEO,
		value: "pj9cNnT7PJs"
	},
	{
		id: "3",
		type: SourceType.IMAGE,
		value: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
	},
	{
		id: "4",
		type: SourceType.IMAGE,
		value: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
	},
	{
		id: "5",
		type: SourceType.VIDEO,
		value: "pj9cNnT7PJs"
	},
	{
		id: "7",
		type: SourceType.IMAGE,
		value: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
	},
	{
		id: "8",
		type: SourceType.IMAGE,
		value: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
	},
	{
		id: "9",
		type: SourceType.VIDEO,
		value: "pj9cNnT7PJs"
	},
	{
		id: "10",
		type: SourceType.IMAGE,
		value: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
	},
	{
		id: "11",
		type: SourceType.IMAGE,
		value: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
	},
	{
		id: "12",
		type: SourceType.VIDEO,
		value: "pj9cNnT7PJs"
	}
	*/
];

// note : data of about program
export interface ProgramProps {
	title: string;
	text: string;
	icon: string;
	image?: string;
}
export const DATA_PROGRAM: ProgramProps[] = [
	{
		title: "피지컬 컴퓨팅",
		text: `몸의 움직임과 연동할 수 있는 아두이노 기반의 디바이스를 활용합니다. 빛과 소리, 움직임이라는 감각을 활용해 입출력장치를 동작시키게 됩니다.`,
		icon: "arduino",
		image: "https://images.unsplash.com/photo-1553063085-dbbf64d936ea?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2689&q=80"
	},
	{
		title: "비주얼 그래픽",
		text: `비주얼 프로그래밍 언어인 터치디자이너를 활용합니다. 웹캠, 마이크, 키보드, 마우스 등의 입력창치를 활용해 3D오브젝트나 파티클과 같은 그래픽을 만들어 냅니다.`,
		icon: "touchdesigner",
		image: "https://images.unsplash.com/photo-1593572547344-d8c3d0ff7d12?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1275&q=80"
	},
	{
		title: "무브먼트",
		text: `프로그램 전반에서 다뤄지며 이야기를 이끌어주는 영역으로 자신이 표현하는 바를 드러낼 수 있게 해줍니다.`,
		icon: "movement",
		image: "https://images.unsplash.com/photo-1511715282680-fbf93a50e721?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80"
	}
];

// note : data of about process
export interface ProcessProps {
	type: string;
	contents: ProcessContentsProps[];
}

export interface ProcessContentsProps {
	name: string;
	title: string;
}

export const DATA_PROCESS: ProcessProps[] = [
	{
		type: "탐색하기",
		contents: [
			{
				name: "수업 탐색",
				title: "42호 탑승하기"
			},
			{
				name: "스토리 탐색",
				title: "깊은 생각에게 물어봐"
			}
		]
	},
	{
		type: "익히기",
		contents: [
			{
				name: "도구 익히기 기본 1",
				title: "Don’t Panic! 감각 증폭기"
			},
			{
				name: "도구 익히기 기본 2",
				title: "Don’t Panic! 은하수어 번역기"
			},
			{
				name: "도구 익히기 기본 3",
				title: "Don’t Panic! 4차원 망원경"
			},
			{
				name: "도구 익히기 응용",
				title: "Don’t Panic! 행성 레시피"
			}
		]
	},
	{
		type: "창작하기",
		contents: [
			{
				name: "기획",
				title: "Design Up! Z플래닛"
			},
			{
				name: "제작",
				title: "Make Up! Z플래닛"
			},
			{
				name: "제작",
				title: "Make Up! Z플래닛"
			}
		]
	},
	{
		type: "공유하기",
		contents: [
			{
				name: "공유",
				title: "Z플래닛 에피소드 1: 히치하이커들의 여정 [ 온라인 쇼케이스 ]"
			}
		]
	}
];

// note : data of about information
export interface InfoProps {
	icon: string;
	title: string;
	text: string;
	caption?: string;
	link?: string;
}
export const DATA_INFO: InfoProps[] = [
	{
		icon: "date",
		title: "일자",
		text: `2020.09.05(토) ~ 10.31(토)
		매주 토요일, 일요일 2회(총 10회)`
	},
	{
		icon: "time",
		title: "시간",
		text: `오후 1시–4시`,
		caption: "창작하기 단계부터는 시간이 늘어날 수 있습니다."
	},

	{
		icon: "location",
		title: "장소",
		text: `온라인
		Zoom, YouTube, Google`
	},
	{
		icon: "person",
		title: "대상",
		text: `16세–24세 히치하이커 10명
		선발 예정`
	},
	{
		icon: "check",
		title: "준비사항",
		text: `웹캠 포함 노트북.
		안정적이고 고정적으로 참여할 수 있는 수업공간.
		원활한 소통이 가능할 수 있도록 인터넷, 마이크, 스피커가 준비된 수업환경.`
	},
	{
		icon: "price",
		title: "참가비",
		text: `전액 무료`
	},
	{
		icon: "document",
		title: "신청 방법",
		text: `온라인 신청`,
		link: `https://forms.gle/EgjwBmZ48mMsUK38A`
	}
];

// note : data of about sponsor
export const DATA_SPONSOR: string[] = [
	"http://project42.abclab.kr/admin/wp-content/uploads/2020/11/logo_toyo.png",
	"http://project42.abclab.kr/admin/wp-content/uploads/2020/11/logo_mcst.png",
	"http://project42.abclab.kr/admin/wp-content/uploads/2020/11/logo_arte.png",
	"http://project42.abclab.kr/admin/wp-content/uploads/2020/11/logo_abclab.png",
	/*
	"https://cdn.worldvectorlogo.com/logos/cigna-3.svg",
	"https://cdn.worldvectorlogo.com/logos/accredo-health.svg",
	"https://cdn.worldvectorlogo.com/logos/hp-2012.svg",
	"https://cdn.worldvectorlogo.com/logos/bang-olufsen-logo.svg",
	"https://cdn.worldvectorlogo.com/logos/cigna-3.svg",
	"https://cdn.worldvectorlogo.com/logos/accredo-health.svg",
	"https://cdn.worldvectorlogo.com/logos/hp-2012.svg",
	"https://cdn.worldvectorlogo.com/logos/bang-olufsen-logo.svg"

	*/
];
